import { render } from "./RingLoader.vue?vue&type=template&id=0d894e4e&scoped=true"
import script from "./RingLoader.vue?vue&type=script&lang=js"
export * from "./RingLoader.vue?vue&type=script&lang=js"

import "./RingLoader.vue?vue&type=style&index=0&id=0d894e4e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ALEX\\Desktop\\pokemon_card_shipping\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d894e4e"]])

export default __exports__